import React from 'react';
import { Form } from 'antd';
import { AlarmTriggerOptions } from '@utils/alarmsConstants';
import { AlarmThresholdFields } from './AlarmThresholdFields/AlarmThresholdFields';
import { AlarmSeasonalFields } from './AlarmSeasonalFields/AlarmSeasonalFields';
import { AlarmPercentualVariationFields } from './AlarmPercentualVariationFields/AlarmPercentualVariationFields';

export function AlarmTypes() {
  const form = Form.useFormInstance();
  const tipoAlarme = Form.useWatch('tipoAlarme', form);

  if (tipoAlarme === AlarmTriggerOptions.THRESHOLD) {
    return <AlarmThresholdFields />;
  }

  if (tipoAlarme === AlarmTriggerOptions.PERCENTUAL_VARIATION) {
    return <AlarmPercentualVariationFields />;
  }

  if (tipoAlarme === AlarmTriggerOptions.SEASONAL) {
    return <AlarmSeasonalFields />;
  }

  return null;
}
